<template>
    <div>
        <div v-for="(serviceInstance) in serviceInstanceList" :key="serviceInstance.ServiceInstanceId">
            <div class="mb-2">
                <span class="font-weight-bold">{{ serviceInstance.name }}:</span> {{ serviceInstance.status.displayName }}
            </div>
            <div v-for="(serviceWorker,index) in serviceInstance.serviceWorkers" :key="index" class="d-flex">

                <div class="pb-1 w-75">
                    <b-link :href="$urlHelper.getPageUrl('Services')" class="btn border-info bg-light w-75">
                        <span class="">{{ serviceWorker.workerType.displayName }}</span>
                    </b-link>
                </div>

                <div class="h3" v-if="serviceWorker.status.displayName=='Healthy'">
                    <div class="far fa-times-circle pl-1 pr-2" style="color: grey;" />
                    <div class="fas fa-check-circle pl-2 pr-1" style="color: green; " />
                </div>
                <div class="h3" v-else>
                    <div class="fas fa-times-circle pl-1 pr-2" style="color: red;" />
                    <div class="far fa-check-circle pl-2 pr-1" style="color: grey; " />
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';
    import Visibility from 'visibilityjs';
    import ErrorsMixin from '../../../mixins/ErrorsMixin';

    Vue.use(BootstrapVue);
   
    export default {
        name: 'ServiceHealthWidget',
        mixins: [ErrorsMixin],
        props: {
            dashboardWidgetConfigurationId: {
                type: String,
                default: null
            },
            title: {
                type: String,
                default: null
            },
            configuration: {
                type: Object,
                default: null
            },
            widgetMode: {
                type: String,
                default: 'view'
            }
        },
        data: function () {
            return {
                serviceInstanceList: [],
                timer: null,
                refreshIntervalInMilliseconds: 60000
            }
        },
        methods: {
            loadData: function () {
                if (this.dashboardWidgetConfigurationId) {
                    var url = this.$urlHelper.getApiUrl('dashboardwidget', 'data', ['servicehealth', this.dashboardWidgetConfigurationId, 'null']);
                    // providing the null at the end of the url indicates that this widget does not want to deal with time ranges
                    axios
                        .get(url)
                        .then(response => {
                            this.serviceInstanceList = response.data;
                        })
                        .catch(ex => {
                            console.log(JSON.stringify(ex));
                            var currentErrors = this.handleAxiosException(ex);
                            this.showErrorsToast(currentErrors);
                        });
                }
            },
            reloadData: function () {
                if (this.widgetMode == 'view') {
                    this.loadData();
                }
            },
        },
        updated: function () {

        },
        mounted: function () {

            this.loadData();
            this.timer = Visibility.every(this.refreshIntervalInMilliseconds, this.reloadData);
        }
    }
</script>
